import { Grid } from '@mui/material'
import PageHeading from 'components/atoms/PageHeading'
import SchoolSchedule from 'components/utilized/studentDashboard/SchoolSchedule'
import { useTranslation } from 'react-i18next'
import { useGET_timetablesQuery } from 'redux/api/mySchoolApi'

const StudentGroupsPage = () => {
  const { t } = useTranslation()


  return (
    <SchoolSchedule />
  )
}
export default StudentGroupsPage
